import { useEffect, useState } from 'react';
import { useLoadInitialContent } from './useLoadInitialContent';

export enum Brand {
  PH = 'PH',
  'PH-US' = 'PH-US',
}
export default function useSelectBrand() {
  const [brand, setBrand] = useState<Brand>();
  const { loaded, getBrandsContent } = useLoadInitialContent();

  useEffect(() => {
    if (brand) {
      getBrandsContent(brand);
    }
  }, [brand, getBrandsContent]);

  return { loaded, brand, setBrand };
}
